import axios from 'axios';
import { Toast } from 'vant';

const http = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? '//voteone.cqcb.com'
      : '//47.111.130.176:8019',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

function fetchToken() {
  return new Promise((reslove) => {
    const token = window.gettoken();
    reslove(token);
  });
}

// 拦截器
http.interceptors.request.use((config) => {
  if (window.gettoken() && window.gettoken() !== 'null') {
    fetchToken().then((res) => (config.headers.token = `${res}`));
  }
  return config;
});

http.interceptors.response.use(
  (res) => {
    if (res && res.status === 200) {
      if (res.data) {
        return res.data;
      } else {
        return true;
      }
    }
    return Promise.reject();
  },
  (err) => {
    const { response = {} } = err;
    if (response.status === 500) {
      Toast.loading({
        duration: 3000,
        message: '服务器开小差了,后台工作人员正在努力解决',
      });
    }
  },
);
export { http };
